module.exports = "/images/noFoundProduct.svg";